import React, { lazy, Suspense, useContext } from 'react';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter, Switch, Route, Redirect } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import {  QueryClient, QueryClientProvider } from 'react-query';

import PublicLayout from './component/common/PublicLayout';
import AuthLayout from './component/common/AuthLayout';
import DashboardLayout from './component/common/DashboardLayout';

const Login = lazy(() => import('./layout/Auth/Login'));
const Register = lazy(() => import('./layout/Auth/Register'));
const SetPassword = lazy(() => import('./layout/Auth/SetPassword'));
const ForgetPassword = lazy(() => import('./layout/Auth/ForgetPassword'));

const YourLastDeal = lazy(() => import('./component/SideBar/YourLastDeal'));
const BbitStore = lazy(() => import('./component/SideBar/BbitStore'));
const YourStockBox = lazy(() => import('./component/SideBar/YourStockBox'));
const Trade = lazy(() => import('./layout/Trade'));
const Wallet = lazy(() => import('./layout/Wallet'));
const WalleteToman = lazy(() => import('./component/wallet/WalleteToman'));
const WalletBardashToman = lazy(() => import('./component/wallet/walletBardashToman'));
const WalleteBrdashtBitCoin = lazy(() => import('./component/wallet/WalleteBrdashtBitCoin'));
const WalletBitCoin = lazy(() => import('./component/wallet/WalletBitCoin'));
const WalletTeter = lazy(() => import('./component/wallet/WalletTeter'));
const WalletNotification = lazy(() => import('./component/wallet/WalletNotification'));
const Order = lazy(() => import('./component/order/Order'));
const Setting = lazy(() => import('./layout/Setting'));
const InviteFriends = lazy(() => import('./layout/InviteFriends'));

const Dashboard = lazy(() => import('./layout/Dashboard'));
const Profile = lazy(() => import('./layout/Profile'));

const LoadingFallback = ({ type }) =>
    type === 'Dashboard' ? <DashboardLayout></DashboardLayout> : <AuthLayout></AuthLayout>;

export const PublicRoutes = ({ children, ...rest }) => {
    return <Route {...rest} render={() => <PublicLayout>{children}</PublicLayout>}></Route>;
};

export const AuthenticatedRoute = ({ children, path, ...rest }) => {
    //Use Context
    // const { state } = useContext(UserContext);
    return (
        <Route
            {...rest}
            render={() => (true ? <DashboardLayout>{children}</DashboardLayout> : <Redirect to="/login" />)}
        ></Route>
    );
};

export const AuthRoutes = ({ children, ...rest }) => {
    // const { token } = useContext(UserContext);
    return (
        <Route
            {...rest}
            render={() => (true ? <AuthLayout>{children}</AuthLayout> : <Redirect to="/dashboard" />)}
        ></Route>
    );
};
const history = createBrowserHistory();
const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
      },
    },
  });

function App() {
    return (
        <BrowserRouter>
            <QueryClientProvider client={queryClient}>
                <div className="app">
                    <Suspense fallback={<LoadingFallback />}>
                        <Switch>
                            <AuthRoutes path="/login">
                                <Login />
                            </AuthRoutes>
                            <AuthRoutes path="/register">
                                <Register />
                            </AuthRoutes>
                            <AuthRoutes path="/set-password">
                                <SetPassword />
                            </AuthRoutes>
                            <AuthRoutes path="/forget-password">
                                <ForgetPassword />
                            </AuthRoutes>
                        </Switch>
                    </Suspense>
                    <Suspense fallback={<LoadingFallback type="Dashboard" />}>
                        <Switch>
                            <AuthenticatedRoute exact path="/">
                                <Dashboard />
                            </AuthenticatedRoute>

                            <PublicRoutes path="/landing">landing</PublicRoutes>

                            <AuthenticatedRoute path="/dashboard">
                                <Dashboard />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/trade">
                                <Trade />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/setting">
                                <Setting />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/profile">
                                <Profile />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/invite-friend">
                                <InviteFriends />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet/deposit-toman">
                                <WalleteToman />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet/withdrawal-toman">
                                <WalletBardashToman />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet/withdrawal-coin">
                                <WalleteBrdashtBitCoin />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet/bitcoin">
                                <WalletBitCoin />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet/tether">
                                <WalletTeter />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/wallet">
                                <Wallet />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/notification">
                                <WalletNotification />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/order">
                                <Order />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/store">
                                <BbitStore />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/your-stock">
                                <YourStockBox />
                            </AuthenticatedRoute>
                            <AuthenticatedRoute path="/latest-deals">
                                <YourLastDeal />
                            </AuthenticatedRoute>

                            {/* <AuthenticatedRoute path="*">
                            <Dashboard />
                        </AuthenticatedRoute> */}
                        </Switch>
                    </Suspense>
                </div>
                <ReactQueryDevtools initialIsOpen={false} />
            </QueryClientProvider>
        </BrowserRouter>
    );
}

export default App;
